module.exports = __webpack_public_path__ + "img/chevron-double-right.715fbff3.svg";